

import Vue from "vue";
import { ToolbarService } from "@/services/toolbar-service";

export default Vue.extend({
	data() {
		return {
			loaded: false
		};
	},
	computed: {

	},
	methods: {

	},
	async mounted() {
		this.loaded = true;
		ToolbarService.title = this.$ct("title");
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "views.SupportRoute.TeamviewerDefault"
	}
});
